export default "__VITE_ASSET__d2a8bc8c__"